module.exports = __webpack_public_path__ + "static/img/shield-2.afcbd83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shield-2.svg
// module id = SmLF
// module chunks = 1